import React, { useState } from "react";
import axios from 'axios';
import { toast } from "react-toastify";


const Contact = () => {


  const [formData, setFormData] = useState({
    userEmail: "",
    userMessage: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


  const handleSubmit = async (e) => {
  e.preventDefault();


  
  try {
    
    
    await axios.post(
      // "https://n8n-7i5l.onrender.com/webhook-test/127b88ce-b418-4228-9246-c029d8de11bb",
      // "https://dev.bibhup.co.in/webhook/127b88ce-b418-4228-9246-c029d8de11bb",
      "https://1drv.ms/o/c/9f9de31a841cda16/IgBi3r_E8NrUSpqqb7I2jQWMAVFjb3pj0c5um0dDGfs5MPk?e=DoGbFd",
      formData,
     {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

    toast.success("Message sent Successfully!");

    // Clear form fields
    setFormData({
      userEmail: "",
      userMessage: "",
    });
  } catch (error) {
    console.error("Error sending Message:", error);
    toast.error("Something went wrong!");
  }
};


  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-100 via-white to-purple-100 flex items-center justify-center px-4 py-12">
      <div className="bg-white/80 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-16 w-full max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Left Side - Contact Form */}
        <div>
          <div className="contact-heading flex flex-row">
            <h2 className="text-4xl md:text-5xl">📬</h2>
            <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r   from-[#3A506B] via-[#5BC0BE] to-[#EDF6F9] text-transparent bg-clip-text mb-8">
              Get in Touch
            </h2>
          </div>
          <form onSubmit={handleSubmit}>
            <input type="hidden" name="_captcha" value="false" />
            <input
              type="hidden"
              name="_next"
              value="https://yourdomain.com/thankyou"
            />
            <div>
              <label className="block text-lg font-medium text-gray-700 mb-2">
                Your Email
              </label>
              <input
                type="email"
                placeholder="example@email.com"
                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
                name="userEmail"
                value={formData.userEmail}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label className="block text-lg font-medium text-gray-700 mb-2">
                Message
              </label>
              <textarea
                rows="6"
                placeholder="Write your message..."
                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
                name="userMessage"
                value={formData.userMessage}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button
              type="submit"
              // className="w-full bg-blue-600 text-white text-lg font-semibold py-3 px-6 rounded-xl hover:bg-blue-700 transition"
              className="w-full mt-4 px-5 py-2.5 text-base font-bold text-white bg-gradient-to-r from-[#246463] via-[#5BC0BE] to-[#9eeeed] rounded-full cursor-pointer transition duration-200 transform hover:scale-105 shadow-md hover:shadow-lg gap-2"
            >
              Let's Talk!
            </button>
          </form>
         
        </div>

        {/* Right Side - Info / Illustration */}
        <div className="flex flex-col justify-center space-y-6">
          <p className="text-lg text-gray-700">
            I’d love to hear from you! Whether you have a question, a project
            idea, or just want to connect — feel free to drop a message.
          </p>

          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <span className="text-blue-600 text-xl">📍</span>
              <p className="text-gray-800">Hyderabad, Telangana, India</p>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-blue-600 text-xl">📧</span>
              <p className="text-gray-800">bibhupattanaik@gmail.com</p>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-blue-600 text-xl">🌐</span>
              <a 
  href="https://bibhup.co.in" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="text-gray-800 hover:underline"
>
  bibhup.co.in
</a>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
